export const SETTINGS_SECTION_PREFIX = 'settings-section-';
export const SETTINGS_SCROLL_ROOT_SELECTOR = '[data-app-scroll-container]';
export const SETTINGS_ACTIVATION_OFFSET = 48;
export const SETTINGS_SCROLL_END_TOLERANCE = 4;

export const getSettingsScrollRoot = () => document.querySelector(SETTINGS_SCROLL_ROOT_SELECTOR);

export const getSettingsSectionElement = (id) => document.getElementById(`${SETTINGS_SECTION_PREFIX}${id}`);

export const getSettingsSectionId = (element) =>
    element?.dataset.settingsSection || element?.id?.replace(SETTINGS_SECTION_PREFIX, '');

export const getHashSectionId = (hash) => hash.replace(/^#/, '');
